var map = {
	"./50x.png": "c576b",
	"./Binance Futures.png": "8fc1",
	"./Binance Spot.png": "d2ed",
	"./Binance.png": "f0d2",
	"./Bitmex Futures.png": "9103",
	"./Bitmex.png": "dd71",
	"./abcc.png": "ffef",
	"./daniil.png": "e3b3",
	"./daniil_80x80.png": "e057",
	"./logo-aivia-inverted.png": "3a63",
	"./logo-black.png": "3056",
	"./logo-dark.png": "954d",
	"./logo.png": "013a",
	"./logo@2x.png": "1bdb",
	"./metamask.png": "365f",
	"./no-image.png": "2c0c",
	"./zhdun.png": "b320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d488";